import React from 'react';
import '../CSS/Team.css';
import DilipMoraniImage from '../Images/Team/Dilip Morani.jpg';
import KavitaMoraniImage from '../Images/Team/kavita morani.jpg';
import MukeshImage from '../Images/Team/Mukesh.png';
import ManishImage from '../Images/Team/Manish.jpg';
import JayImage from '../Images/Team/Jay.jpg';
import NeerajImage from '../Images/Team/Neeraj.jpeg';
import HarshImage from '../Images/Team/Harsh.jpeg';
import MohanImage from '../Images/Team/Mohan.jpeg';

const teamMembers = [
  {
    name: 'Mr. Dilip Morani',
    title: 'CEO & Founder',
    image: DilipMoraniImage,
    bgColor: '#FFF8E1',
    desc: "With over 34 years of rich experience in the insurance and mutual fund industry, Dilip Morani brings deep insight, trust, and strategic direction to Valuefundz. A Commerce graduate, he has built a legacy of excellence through long-standing client relationships, ethical advisory, and a strong focus on financial awareness. As the founder and guiding force of the firm, his leadership continues to inspire a client-centric culture and a commitment to long-term value creation.",
  },
  {
    name: 'Mrs. Kavita Morani',
    title: 'Director',
    image: KavitaMoraniImage,
    bgColor: '#FCE4EC',
    desc: "Kavita Morani, a Science graduate (B.Sc), brings over 25 years of experience in the financial services industry. As a Director at Valuefundz, she has played a key role in building client trust and ensuring operational excellence. Her meticulous approach, deep understanding of insurance and mutual funds, and commitment to client well-being have been instrumental in shaping the firm’s strong reputation and client-first philosophy.",
  },
  {
    name: 'Mukesh Tekwani',
    title: 'Manager',
    image: MukeshImage,
    bgColor: '#E1F5FE',
    desc: "Mr. Mukesh Tekwani is a Commerce graduate and post-graduate with over 10 years of experience in the financial services industry. As Manager at Valuefundz Private Limited, he plays a pivotal role in handling mutual fund operations, sales, and client servicing. His responsibilities include overseeing day-to-day operational activities, supporting business development, and ensuring compliance with regulatory standards. With a strong background in commerce and a deep understanding of mutual fund distribution, Mr. Tekwani contributes significantly to the firm's operational efficiency and client satisfaction.",
  },
  {
    name: 'Manish Gyanani',
    title: 'Relationship Manager',
    image: ManishImage,
    bgColor: '#FFF3E0',
    desc: "With 4 years of experience at Valuefundz, Manish plays a key role in mutual fund back-office operations, sales coordination, and client relationship management. A B.Com graduate, he is known for his dependable client service and operational efficiency.",
  },
  {
    name: 'Jay Kumar Khtari',
    title: 'Life & Health Insurance Manager',
    image: JayImage,
    bgColor: '#E3F2FD',
    desc: "Jay brings over 5 years of experience at Valuefundz, managing proposal logins, claims, and client servicing in life and health insurance. A B.Com graduate with a National Insurance Agency BQP certification, he ensures seamless execution and support across all insurance-related processes.",
  },
  {
    name: 'Neeraj Tolani',
    title: 'Social Media Manager',
    image: NeerajImage,
    bgColor: '#FBE9E7',
    desc: "Mr. Neeraj Tolani is the Social Media Manager & he is the mind behind all the content we post.",
  },
  {
    name: 'Harsh Soni',
    title: "Customer Relationship Manager – General Insurance",
    image: HarshImage,
    bgColor: '#FBE9E7',
    desc: "Harsh is a BA graduate with 4 years of experience in general insurance, including motor, home, factory, and fire policies. He specializes in customer relationship management and also oversees the end-to-end insurance claims process to ensure smooth resolution.",
  },
];

const MeetOurTeam = () => {
  return (
    <div className="team-container justify-content-center align-items-center">
      <h1 className="team-title">INTRODUCTION OF<br /><span className="highlight">OUR TEAM</span></h1>
      <div className="team-grid justify-content-center align-items-center">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <div className="image-wrapper">
                <img src={member.image} alt={member.name} className="team-image" />
            </div>
            <h3 className="team-name">{member.name.toUpperCase()}</h3>
            <h2 className="team-name">{member.title.toUpperCase()}</h2>
            <p className="team-description text-justify-custom">{member.desc}</p>
          </div>
        ))}
      </div>
    </div>
  
  );
};

export default MeetOurTeam;
